// ProV4 add-on forms: Additional Name/Number (prov4-addnum-input.liquid) and Re-Order (prov4-reorder-input.liquid).
// Shared field helpers live in prov4-fields.js.
if (!customElements.get('prov4-addon-fields')) {
  customElements.define(
    'prov4-addon-fields',
    class Prov4AddonFields extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        // Match Current Order (Additional Name/Number only): No asks for the Original Order #
        if (this.querySelector('[data-match-current-order]')) {
          this.querySelectorAll('[data-match-current-order]').forEach(radio => {
            radio.addEventListener('change', () => this.updateMatchCurrentOrder());
          });
          this.updateMatchCurrentOrder();
        }

        // Same Car Number/Class? and Same Driver Name? pills
        this.querySelectorAll('[data-same-choice]').forEach(radio => {
          radio.addEventListener('change', () => this.updateGroups());
        });

        this.setupDecalSizing();
        Prov4Fields.bindSecondFieldToggles(this);
        Prov4Fields.bindUnknownToggles(this);
        Prov4Fields.bindRequiredCheck(this);
        this.setupVariantChangeListener();
        this.updateGroups();

        // Opened from the cart's Edit button: fill from that cart line (prov4-fields.js)
        Prov4Edit.loadItem().then(item => {
          if (item) Prov4Edit.start(this, item, this.sectionId);
        });
      }

      updateMatchCurrentOrder() {
        const choice = this.querySelector('[data-match-current-order]:checked');
        const value = choice ? choice.value : '';
        this.querySelector('[data-match-selected]').textContent = value;
        const field = document.getElementById(`prov4-original-order-field-${this.sectionId}`);
        field.style.display = value === 'No' ? '' : 'none';
        Prov4Fields.setFieldEnabled(field.querySelector('input'), value === 'No', true);
      }

      // A variant with car numbers shows the numbers group, one with driver names the names group
      // (a full re-order kit shows both). Each group's fields only show (and save) when its pill is No.
      updateGroups() {
        const kinds = this.getVariantKinds();
        this.querySelectorAll('[data-same-group]').forEach(group => {
          const groupShown = kinds.includes(group.dataset.sameGroup);
          group.style.display = groupShown ? '' : 'none';

          const choice = group.querySelector('[data-same-choice]:checked');
          const same = choice ? choice.value : 'Yes';
          const sameInput = group.querySelector('[data-same-input]');
          sameInput.value = same;
          sameInput.disabled = !groupShown;
          group.querySelector('[data-same-selected]').textContent = same;

          const detailsShown = groupShown && same === 'No';
          const details = group.querySelector('[data-same-no-fields]');
          details.style.display = detailsShown ? '' : 'none';

          details.querySelectorAll('.prov4-text-input-field:not(.prov4-second-field) input').forEach(input => {
            // Class Designation is optional; Car Number and Driver Name are required
            const required = !input.id.startsWith('prov4-class-designation-');
            Prov4Fields.setFieldEnabled(input, detailsShown, required);
          });
          if (!detailsShown) {
            details.querySelectorAll('[data-second-field-toggle]').forEach(toggle => Prov4Fields.resetSecondField(toggle));
          }
        });
      }

      // e.g. "Car Number [+$5]" -> ['numbers'], "Door Car Kit (4 Car Numbers/2 Driver Names)" -> ['numbers', 'names']
      getVariantKinds() {
        const variant = this.getCurrentVariant();
        if (!variant) return [];
        const text = [variant.title, variant.option1, variant.option2, variant.option3].join(' ').toLowerCase();
        const kinds = [];
        if (text.includes('car number')) kinds.push('numbers');
        if (text.includes('driver name')) kinds.push('names');
        return kinds;
      }

      getCurrentVariant() {
        const variantDataScript = document.querySelector('variant-selects [data-selected-variant]');
        if (!variantDataScript) return null;
        try {
          return JSON.parse(variantDataScript.textContent);
        } catch (e) {
          return null;
        }
      }

      setupVariantChangeListener() {
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.sectionId === this.sectionId) this.updateGroups();
          });
        }

        // Fallback: watch the variant data script for changes
        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          this.variantObserver = new MutationObserver(() => this.updateGroups());
          this.variantObserver.observe(variantSelects, { childList: true, subtree: true, characterData: true });
        }
      }

      setupDecalSizing() {
        const hiddenInput = document.getElementById(`prov4-decal-sizing-input-${this.sectionId}`);
        const selectedValue = document.getElementById(`prov4-decal-sizing-selected-${this.sectionId}`);
        const customField = document.getElementById(`prov4-custom-sizing-details-${this.sectionId}`);
        const update = (value) => {
          hiddenInput.value = value;
          selectedValue.textContent = value;
          customField.style.display = value === 'Custom Size' ? '' : 'none';
          Prov4Fields.setFieldEnabled(customField.querySelector('input'), value === 'Custom Size', true);
        };
        const radios = this.querySelectorAll(`input[name="prov4-decal-sizing-${this.sectionId}"]`);
        radios.forEach(radio => radio.addEventListener('change', (e) => update(e.target.value)));
        const checked = Array.from(radios).find(radio => radio.checked);
        if (checked) update(checked.value);
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.variantObserver) this.variantObserver.disconnect();
      }
    }
  );
}
